<template lang="pug">
include /../../s-pug/mixin-icon
._mx1-5._py075
   button._AddItemBtn._radius._w100._px1-5._py1._bg-grey-050._flex._flex-alignItemsCenter._whenDisabled-noEvents(@click="onClick")
      ._AddItemBtn-icon: +icon({name: 'icon-add-circle'})
      ._ml1._c-grey-500._ls-1-5._fs-3 Add {{noun}}
</template>

<style lang="sass" scoped>
._AddItemBtn
   // border-top: dashed 1px transparent
   // border-bottom: dashed 1px transparent
   border: dashed 1px transparent
   cursor: pointer
   &:hover:not([disabled])
      // border-top-color: $light-blue-vivid-700
      // border-bottom-color: $light-blue-vivid-700
      // border-bottom-style: dashed
      border-color: $light-blue-vivid-700
   &:disabled
      cursor: default
   .is-childBeingDragged &
      cursor: unset
      &:hover
         // border-top-color: transparent
         // border-bottom-color: transparent
         border-color: transparent
._AddItemBtn-icon svg
   +wh(24px)
   display: inherit
   .primary
      fill: $grey-100
   .secondary
      fill: $light-blue-vivid-800
</style>

<script>
export default {
   name: 'ProfileEditNewItemBtn',
   props: {
      noun: String,
   },
   methods: {
      onClick() {
         this.$emit('onClick')
      },
   },
}
</script>
